/**
 * MOBY Sticky Bar
 * Reads Liquid values from data-* attributes on #moby-sticky-bar element.
 */
function orderTotal(unitPrice, quantity, isSubscription) {
  const safePrice = Number(unitPrice) || 0;
  const safeQuantity = Math.max(1, Number(quantity) || 1);
  return isSubscription ? safePrice * safeQuantity : safePrice;
}

function tierDataFromChange(detail, basePrice) {
  const isSub = detail && detail.isSubscription !== false;
  const qty = Math.max(1, Number(detail && detail.quantity) || 1);
  const fallbackPrice = isSub ? 0 : Number(basePrice) || 0;
  const price = Number(detail && detail.unitPrice) || fallbackPrice;
  const savings = isSub && basePrice > 0
    ? Math.round((basePrice - price) / basePrice * 100)
    : 0;

  const recurringPrice = Number(detail && detail.recurringPrice) || price;
  return { price, recurringPrice, qty, isSub, savings };
}

function formatStickyMoney(cents, currency, locale) {
  const safeCurrency = currency || 'SEK';
  const amount = (Number(cents) || 0) / 100;
  if (['SEK', 'NOK', 'DKK'].includes(safeCurrency)) {
    return amount.toLocaleString(locale || 'sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr';
  }
  return new Intl.NumberFormat(locale || 'en', {
    style: 'currency',
    currency: safeCurrency
  }).format(amount);
}

function formatStickyPerServing(cents, currency, locale, krSuffix, suffix) {
  const amount = (Number(cents) || 0) / 100 / 30;
  const safeCurrency = currency || 'SEK';
  if (['SEK', 'NOK', 'DKK'].includes(safeCurrency)) {
    return amount.toLocaleString(locale || 'en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + (krSuffix || 'kr / serving');
  }
  return amount.toLocaleString(locale || 'en', {
    style: 'currency', currency: safeCurrency, minimumFractionDigits: 2, maximumFractionDigits: 2
  }) + ' ' + (suffix || '/ serving');
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { orderTotal, formatStickyMoney, formatStickyPerServing, tierDataFromChange };
}

if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function() {
    const stickyBar = document.getElementById('moby-sticky-bar');
    // es-module-shims can dispatch DOMContentLoaded a second time. A second
    // setup would save the pending button as its "original" label and restore
    // that after the add, leaving the button stuck on "Adding…".
    if (stickyBar) {
      if (stickyBar.dataset.mobyStickyInit === 'true') return;
      stickyBar.dataset.mobyStickyInit = 'true';
    }

    // Find the actual add-to-cart button (prioritize MOBY buy box submit btn, then fallbacks)
    const mainAddToCart = document.querySelector(
      '.moby-buy-box__add-btn, ' +
      '#moby-buy-box-form button[type="submit"], ' +
      '[data-product-form] button[type="submit"], ' +
      '.product-form__submit, ' +
      'form[action*="/cart/add"] button[type="submit"]'
    );

    // "Choose plan" mode: open the plan drawer (every plan and its real
    // charge visible) on whichever plan the buy box has selected, instead of
    // adding to cart. Without the drawer the link's own #moby-buy-box anchor
    // scrolls to the plans.
    const choosePlanLink = stickyBar && stickyBar.querySelector('[data-sticky-choose-plan]');
    if (choosePlanLink) {
      const openPlanChoice = function(e) {
        if (typeof window.openSubscriptionDrawer !== 'function') return;
        e.preventDefault();
        const selected = document.querySelector('.moby-buy-box__option.is-selected');
        window.openSubscriptionDrawer((selected && selected.dataset.option) || 'subscribe');
      };
      choosePlanLink.addEventListener('click', openPlanChoice);
      // role="button": Space activates it like a real button.
      choosePlanLink.addEventListener('keydown', function(e) {
        if (e.key === ' ') openPlanChoice(e);
      });
    }

    if (!stickyBar || !mainAddToCart) return;

    const addToCartBtn = stickyBar.querySelector('[data-sticky-add-to-cart]');
    const notifyBtn = stickyBar.querySelector('[data-sticky-notify]');
    const originalAddToCartHTML = addToCartBtn ? addToCartBtn.innerHTML : '';

    // Subscription-aware elements
    const stickyPrice = stickyBar.querySelector('[data-sticky-price]');
    const stickyCompare = stickyBar.querySelector('[data-sticky-compare]');
    const stickyBadge = stickyBar.querySelector('[data-sticky-badge]');
    const stickyServing = stickyBar.querySelector('[data-sticky-serving]');
    let stickyBtnText = stickyBar.querySelector('[data-sticky-btn-text]');
    let stickyBtnPrice = stickyBar.querySelector('[data-sticky-btn-price]');

    const hasSellingPlans = stickyBar.dataset.hasSellingPlans === 'true';
    const basePrice = parseInt(stickyBar.dataset.basePrice) || 0;
    const subPrice = parseInt(stickyBar.dataset.subPrice) || 0;
    const subSavings = parseInt(stickyBar.dataset.subSavings) || 0;

    const stickyQtyPrefix = stickyBar.querySelector('[data-sticky-qty-prefix]');

    // Track current active tier from buy box
    let activeTierData = { price: subPrice, recurringPrice: Number(stickyBar.dataset.recurringPrice) || subPrice, savings: subSavings, qty: 1, isSub: true };
    let labelCart = null;
    const buttonLabels = Array.from(stickyBar.querySelectorAll('[data-sticky-btn-text], [data-sticky-btn-text-mobile]')).map(function(element) { return { selector: element.hasAttribute('data-sticky-btn-text-mobile') ? '[data-sticky-btn-text-mobile]' : '[data-sticky-btn-text]', fallback: element.textContent }; });
    async function refreshPurchaseLabel() {
      labelCart = await window.MobyCart.get();
      updateStickyBar();
    }
    document.addEventListener('cart:updated', function() { refreshPurchaseLabel().catch(function() {}); });
    refreshPurchaseLabel().catch(function() {});

    function formatMoney(cents) {
      const currency = stickyBar.dataset.currency || 'SEK';
      return formatStickyMoney(cents, currency, stickyBar.dataset.locale || 'en');
    }

    function formatPerServing(cents) {
      return formatStickyPerServing(cents, stickyBar.dataset.currency, stickyBar.dataset.locale,
        stickyBar.dataset.textPerServingKr, stickyBar.dataset.textPerServing);
    }

    // Update sticky bar to reflect current purchase option
    function updateStickyBar() {
      if (!hasSellingPlans) return;
      if (labelCart && window.MobyCart.purchaseLabel) {
        const plan = document.querySelector('#selling-plan-input')?.value || '';
        buttonLabels.forEach(function(entry) {
          const element = stickyBar.querySelector(entry.selector);
          if (element) element.textContent = window.MobyCart.purchaseLabel(labelCart, addToCartBtn?.dataset.variantId, plan, entry.fallback, true) || entry.fallback;
        });
      }

      // Update qty prefix (e.g. "3x ")
      if (stickyQtyPrefix) {
        stickyQtyPrefix.textContent = activeTierData.qty > 1 ? activeTierData.qty + 'x ' : '';
      }

      if (activeTierData.isSub) {
        var displayPrice = activeTierData.recurringPrice;
        // Plain text only — no innerHTML/<span> injection that would conflict
        // with the new dropdown markup. Suffix (/mo, /mån) is a separate
        // span in markup already, untouched here.
        if (stickyPrice) stickyPrice.textContent = formatMoney(displayPrice);
        if (stickyServing) {
          stickyServing.textContent = formatPerServing(displayPrice);
        }
        // The CTA shows the amount charged for the next order. For the
        // 3-month plan that is three boxes, while the dropdown keeps showing
        // the per-serving price.
        if (stickyBtnPrice) {
          stickyBtnPrice.textContent = formatMoney(orderTotal(activeTierData.price, activeTierData.qty, activeTierData.isSub));
        }
        // The savings badge stays hidden (IM8-style): the plan dropdown right
        // next to it already reads "3-Month Supply (Save 45%)", so a separate
        // badge just repeats it. Kept in the DOM and updated for legacy JS
        // hooks, but never shown.
        if (stickyBadge && activeTierData.savings > 0) {
          stickyBadge.textContent = (stickyBar.dataset.textSave || 'Save') + ' ' + activeTierData.savings + '%';
        }
        // Button text stays "ADD" / "ADD TO CART" (set in Liquid). No flip
        // between Subscribe / Add to cart on tier change — keeps the sticky
        // bar visually stable like IM8.
      } else {
        if (stickyPrice) stickyPrice.textContent = formatMoney(basePrice);
        if (stickyServing) {
          stickyServing.textContent = formatPerServing(basePrice);
        }
        if (stickyBtnPrice) stickyBtnPrice.textContent = formatMoney(basePrice);
        // One-time carries no discount, so blank the (hidden) badge rather
        // than leaving the last subscription tier's savings in the DOM.
        if (stickyBadge) stickyBadge.textContent = '';
      }
    }

    // Initialize from whichever buy box option is currently selected
    if (hasSellingPlans) {
      var selectedOption = document.querySelector('.moby-buy-box__option.is-selected');
      if (selectedOption) {
        var initType = selectedOption.dataset.option;
        var initSub = initType !== 'onetime';
        var initQty = parseInt(selectedOption.dataset.quantity) || 1;
        var initPrice = parseInt(selectedOption.dataset.firstPrice) || subPrice;
        var initSavings = initSub ? Math.round((basePrice - initPrice) / basePrice * 100) : 0;
        activeTierData = { price: initPrice, recurringPrice: Number(selectedOption.dataset.recurringPrice) || initPrice, savings: initSavings, qty: initQty, isSub: initSub };
      }
      updateStickyBar();
    }

    // Listen for purchase option changes from buy box
    document.addEventListener('click', function(e) {
      const option = e.target.closest('.moby-buy-box__option');
      if (!option) return;
      const optionType = option.dataset.option;
      if (!optionType) return;

      var isSub = optionType !== 'onetime';
      var qty = parseInt(option.dataset.quantity) || 1;
      var tierPrice = parseInt(option.dataset.firstPrice) || subPrice;
      var savings = isSub ? Math.round((basePrice - tierPrice) / basePrice * 100) : 0;

      activeTierData = { price: tierPrice, recurringPrice: Number(option.dataset.recurringPrice) || tierPrice, savings: savings, qty: qty, isSub: isSub };
      updateStickyBar();
    });

    // Also listen for radio input changes (keyboard/accessibility)
    document.addEventListener('change', function(e) {
      if (e.target.name === 'purchase_option') {
        var option = e.target.closest('.moby-buy-box__option');
        if (option) {
          var optionType = option.dataset.option;
          var isSub = optionType !== 'onetime';
          var qty = parseInt(option.dataset.quantity) || 1;
          var tierPrice = parseInt(option.dataset.firstPrice) || subPrice;
          var savings = isSub ? Math.round((basePrice - tierPrice) / basePrice * 100) : 0;
          activeTierData = { price: tierPrice, recurringPrice: Number(option.dataset.recurringPrice) || tierPrice, savings: savings, qty: qty, isSub: isSub };
          updateStickyBar();
        }
      }
    });

    // Function to check stock and update button state
    async function checkStockAndUpdateButton(event) {
      if (!addToCartBtn) return;

      const productId = addToCartBtn.dataset.productId;
      const inventoryQty = parseInt(addToCartBtn.dataset.inventoryQuantity) || 0;
      const inventoryPolicy = addToCartBtn.dataset.inventoryPolicy || 'deny';

      if (inventoryPolicy !== 'deny') return;

      try {
        // A settled cart:updated event already carries the full cart.
        const settledCart = event && event.detail && Array.isArray(event.detail.items) ? event.detail : null;
        if (!settledCart) window.MobyCart.invalidate();
        const cart = settledCart || await window.MobyCart.get();

        let currentQtyInCart = 0;
        cart.items.forEach(item => {
          if (String(item.product_id) === String(productId)) {
            currentQtyInCart += item.quantity;
          }
        });

        if (currentQtyInCart >= inventoryQty) {
          addToCartBtn.classList.add('moby-sticky-bar__button--notify');
          addToCartBtn.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
            <span class="moby-sticky-bar__button-text">${stickyBar.dataset.textNotifyMe || 'Notify Me'}</span>
          `;
          addToCartBtn.dataset.stockExhausted = 'true';
        } else {
          addToCartBtn.classList.remove('moby-sticky-bar__button--notify');
          if (addToCartBtn.dataset.stockExhausted === 'true') {
            addToCartBtn.innerHTML = originalAddToCartHTML;
            stickyBtnText = addToCartBtn.querySelector('[data-sticky-btn-text]');
            stickyBtnPrice = addToCartBtn.querySelector('[data-sticky-btn-price]');
            updateStickyBar();
          }
          addToCartBtn.dataset.stockExhausted = 'false';
        }
      } catch (error) {
        console.error('Stock check error:', error);
      }
    }

    // Check stock on page load
    checkStockAndUpdateButton();

    // Listen for cart updates
    document.addEventListener('cart:refresh', checkStockAndUpdateButton);
    document.addEventListener('cart:updated', checkStockAndUpdateButton);

    // Keep the fixed CTA visible from the moment the PDP loads. It is no
    // longer gated by the main purchase form's viewport position.
    function applyStickyVisibility() {
      // The sticky bar is shown for every purchase tier. It used to hide
      // for one-time because that tier auto-added to cart; that instant
      // ATC is gone, so the bar must stay available as the buy button.
      stickyBar.setAttribute('data-hidden', 'false');
    }
    applyStickyVisibility();

    // ── Plan select dropdown (IM8-style) ────────────────────────────────
    // Native <select> inside the sticky bar with two options: 1M (default)
    // and 1M. Changing the select clicks the matching tier card in the
    // main buy box, which triggers the existing tier-selection flow and
    // updates the sticky price via the existing click/change listeners
    // on .moby-buy-box__option.
    const planSelect = stickyBar.querySelector('[data-sticky-plan-select]');
    const planLabel = stickyBar.querySelector('[data-sticky-plan-label]');
    const shortPlanLabel = stickyBar.querySelector('[data-sticky-plan-label-short]');

    function mainOptionForPlan(planKey) {
      const dataOption = planKey === '3m' ? 'subscribe-3'
                       : planKey === '1m' ? 'subscribe'
                       : 'onetime';
      return document.querySelector('.moby-buy-box__option[data-option="' + dataOption + '"]');
    }

    function updateStickyPlanLabel() {
      if (!planSelect || !planLabel) return;
      const opt = planSelect.options[planSelect.selectedIndex];
      if (opt) {
        planLabel.textContent = opt.text.trim();
        if (shortPlanLabel) shortPlanLabel.textContent = opt.dataset.shortLabel || opt.text.trim();
      }
    }

    function setStickyPlanValue(planKey) {
      if (planSelect && planSelect.value !== planKey) {
        planSelect.value = planKey;
        updateStickyPlanLabel();
      }
    }

    if (planSelect) {
      planSelect.addEventListener('change', function() {
        const planKey = this.value;
        updateStickyPlanLabel();
        const mainTierEl = mainOptionForPlan(planKey);
        if (mainTierEl && typeof mainTierEl.click === 'function') {
          mainTierEl.click();
        }
      });
    }

    // Listen for buy-box tier changes (dispatched by moby-buy-box.js) and
    // mirror the active plan in the sticky select. The existing click/change
    // listeners above already update the sticky price/badge/serving from
    // data attributes; this listener only needs to keep the select value
    // in sync. The select carries a matching option for every tier
    // (3m / 1m / onetime), so the two stay aligned in both directions.
    document.addEventListener('mobyTierChange', function(e) {
      if (!e.detail || !e.detail.plan) return;

      // Keep plan, quantity, and price atomic. The click/change listeners are
      // useful fallbacks for older integrations, but relying on them alone can
      // leave the new plan label paired with the previous tier's CTA price.
      if (Number(e.detail.unitPrice) > 0) {
        activeTierData = tierDataFromChange(e.detail, basePrice);
        updateStickyBar();
      }

      // The sticky bar stays available for every tier, including
      // one-time. Selecting one-time no longer triggers an instant ATC
      // (see moby-buy-box.js), so the customer still needs a visible
      // add-to-cart button after choosing it.
      if (stickyBar.getAttribute('data-onetime-hidden') === 'true') {
        stickyBar.removeAttribute('data-onetime-hidden');
      }
      applyStickyVisibility();
      setStickyPlanValue(e.detail.plan);
    });

    // Pending while the buy box add is in flight or a cart write is unresolved.
    let stickyPendingHTML = null;
    function syncStickyPending() {
      if (!addToCartBtn) return;
      const buyBoxForm = document.querySelector('#moby-buy-box-form');
      const inFlight = (buyBoxForm && buyBoxForm.dataset.atcInFlight === 'true') || Boolean(window.MobyCart && window.MobyCart.isMutating && window.MobyCart.isMutating());
      if (inFlight) {
        addToCartBtn.disabled = true;
        // Already showing the spinner: rebuilding it would restart the rotation.
        if (stickyPendingHTML !== null) return;
        stickyPendingHTML = addToCartBtn.innerHTML;
        addToCartBtn.innerHTML = '<span class="moby-sticky-bar__button-text">' + window.MobyCart.pendingLabel(stickyBar.dataset.textAdding || 'Adding...') + '</span>';
      } else if (stickyPendingHTML !== null) {
        addToCartBtn.innerHTML = stickyPendingHTML;
        stickyPendingHTML = null;
        // The restored markup is new nodes: re-point the cached refs (as the
        // stock-restore path does) so the current tier's price is written to
        // what is actually on screen.
        stickyBtnText = addToCartBtn.querySelector('[data-sticky-btn-text]');
        stickyBtnPrice = addToCartBtn.querySelector('[data-sticky-btn-price]');
        addToCartBtn.disabled = false;
        updateStickyBar();
      }
    }
    document.addEventListener('moby:cart-state', syncStickyPending);
    document.addEventListener('moby:purchase-pending', syncStickyPending);
    document.addEventListener('cart:updated', syncStickyPending);

    // Handle add to cart / notify me click
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
        // If stock is exhausted, open notify modal
        if (addToCartBtn.dataset.stockExhausted === 'true') {
          const backInStockComponent = document.querySelector('back-in-stock-component');
          if (backInStockComponent && typeof backInStockComponent.openModal === 'function') {
            backInStockComponent.openModal();
          }
          return;
        }

        // Find the main buy box add-to-cart button
        const mainBuyBoxBtn = document.querySelector('.moby-buy-box__add-btn');

        if (mainBuyBoxBtn && mainBuyBoxBtn.disabled) {
          return;
        }

        // The buy box owns validation (one fresh cart read inside
        // addPaidLine) and the add itself. The sticky button mirrors its
        // real in-flight state instead of re-enabling on a timer.
        if (mainBuyBoxBtn) {
          mainBuyBoxBtn.click();
        } else {
          const productForm = document.querySelector('#moby-buy-box-form, form[action*="/cart/add"]');
          if (productForm) productForm.requestSubmit();
        }
        syncStickyPending();
      });
    }

    // Handle dedicated notify me button click
    if (notifyBtn) {
      notifyBtn.addEventListener('click', function() {
        const backInStockComponent = document.querySelector('back-in-stock-component');
        if (backInStockComponent && typeof backInStockComponent.openModal === 'function') {
          backInStockComponent.openModal();
        } else {
          const notifyButton = document.querySelector('.back-in-stock__button, [ref="notifyButton"]');
          if (notifyButton) {
            notifyButton.click();
          }
        }
      });
    }
  });
}
